// Service catalog for credenciamento.
export const SERVICE_GROUPS = [
  {
    id: "consultas",
    label: "Consultas Médicas (Especialidades)",
    items: [
      "Clínica Geral / Medicina da Família",
      "Pediatria",
      "Ginecologia e Obstetrícia",
      "Cardiologia",
      "Ortopedia e Traumatologia",
      "Dermatologia",
      "Oftalmologia",
      "Otorrinolaringologia",
      "Endocrinologia",
      "Urologia",
      "Neurologia",
      "Gastroenterologia",
      "Psiquiatria",
    ],
  },
  {
    id: "saude_mental",
    label: "Saúde Mental e Bem-estar",
    items: [
      "Psicologia Clínica",
      "Terapia Ocupacional",
      "Nutrição",
      "Fonoaudiologia",
      "Fisioterapia Preventiva e Reabilitativa",
    ],
  },
  {
    id: "exames",
    label: "Exames Laboratoriais e Imagem",
    items: [
      "Análises Clínicas (Sangue, Urina, Fezes)",
      "Radiografia (Raio-X)",
      "Ultrassonografia (Geral e Obstétrica)",
      "Ecocardiograma",
      "Eletrocardiograma",
      "Eletroencefalograma",
      "Endoscopia Digestiva Alta",
      "Tomografia Computadorizada",
      "Ressonância Magnética",
      "Mamografia",
      "Colonoscopia",
    ],
  },
  {
    id: "odontologia",
    label: "Odontologia",
    items: [
      "Odontologia Geral",
      "Ortodontia (Aparelhos)",
      "Odontopediatria",
      "Endodontia (Canal)",
      "Periodontia (Gengiva)",
    ],
  },
  {
    id: "outros",
    label: "Outros serviços",
    items: [
      "Serviços de Urgência 24h",
      "Telemedicina (Consulta Online)",
      "Vacinação e Imunização",
      "Check-up Executivo / Preventivo",
      "Atendimento Domiciliar (Home Care)",
      "Serviços de Farmácia (Desconto em Medicamentos)",
      "Óticas",
      "Estética Médica",
      "Academias e Studios de Pilates",
      "Outros",
    ],
  },
];

export const ALL_SERVICES = SERVICE_GROUPS.flatMap((g) => g.items);

export const DISCOUNT_TIERS = [5, 10, 15, 20, 25, 30, 40, 50];
export const DURATION_OPTIONS = [3, 6, 12];

export const PARTNER_STATUS_LABELS = {
  rascunho: { label: "Rascunho", color: "#64748B", bg: "#F1F5F9" },
  convite_enviado: { label: "Convite enviado", color: "#0EA5E9", bg: "#E0F2FE" },
  aguardando_validacao: { label: "Aguardando validação", color: "#F59E0B", bg: "#FEF3C7" },
  aguardando_assinatura: { label: "Aguardando assinatura", color: "#8B5CF6", bg: "#EDE9FE" },
  ativo: { label: "Ativo no catálogo", color: "#10B981", bg: "#D1FAE5" },
  recusado: { label: "Recusado", color: "#EF4444", bg: "#FEE2E2" },
};
